import * as Actions from './type';

import WizardApi from '../../api/users/WizardApi';

export const wizard = (req) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.USER_WIZARD_REQUEST,
    });

    const { data } = await WizardApi(req);
    let userData = JSON.parse(localStorage.getItem('userData') || []);

    // if (!userData?.userStore) {
    userData.userStore = data.data;

    if (data?.token) {
      userData.token = data.token;
    }

    if (req?.subscriptionId) {
      userData.subscriptionId = req.subscriptionId;
    }
    userData = JSON.stringify(userData);
    localStorage.setItem('userData', userData);
    // }
    // const changedData = { ...userData, userStore: data?.data };
    // localStorage.setItem('userData', JSON.stringify(changedData));
    dispatch({
      type: Actions.USER_WIZARD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.USER_WIZARD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
